import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Alert } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
export const ChangeEmailAlert = ({ onDismiss, isVisible }) => {
    const { t } = useTranslation();
    return isVisible ? (_jsx(Alert, { isDismissible: true, onDismiss: onDismiss, variant: 'positive', mb: 'spaceL', children: t('loginregistration.login.changedEmailAlert') })) : null;
};
//# sourceMappingURL=ChangeEmailAlert.js.map